import { Cradle } from "services/serviceContainer.types";

export const makeI18n = ({ i18nInitializer }: Pick<Cradle, "i18nInitializer">) => {
  return i18nInitializer.initI18n();
};
